<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-16 col-md-6">
                    <h3>Job Info</h3>
                </div>
                <div class="col-sm-16 col-md-6 text-right">
                    <a
                        href="#"
                        @click.prevent="toggleShow"
                        v-show="!show"
                    >Show job info <i class="fas fa-eye" /></a>
                    <a
                        href="#"
                        @click.prevent="toggleShow"
                        v-show="show"
                    >Hide job info <i class="far fa-eye-slash" /></a>
                </div>
            </div>

            <transition name="slide">
                <div v-if="show && job">
                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <h5>Name</h5>
                            {{ job.name }}
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <h5>Type</h5>
                            <span v-if="job.is_call_out">Call Out</span>
                            <span v-else>Scheduled</span>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <h5>Status</h5>
                            {{ job.status | capitalize }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <h5>First name</h5>
                            {{ job.first_name }}
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <h5>Last name</h5>
                            {{ job.last_name }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 my-4">
                            <h5>Important Info</h5>
                            {{ job.important_info || 'No important info' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <h5>Description</h5>
                            {{ job.description || 'No description' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: job.id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fas fa-external-link-alt" /> View Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: job.id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit'"
                            >
                                <i class="fas fa-external-link-alt" /> View Job
                            </router-link>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import JobService from '../../../services/JobService';
export default {
    props: {
        jobId: {
            type: [Number, String],
            required: true,
        }
    },
    data() {
        return {
            show: false,
            job: null,
        };
    },

    watch: {
        jobId() {
            this.loadJob();
        }
    },

    mounted() {
        this.loadJob();
    },

    methods: {
        toggleShow() {
            this.show = !this.show;
        },

        loadJob() {
            JobService.get(this.jobId).then(res => {
                this.job = res.data;
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/JobInfoComponent.vue